import React, { useState } from "react";
import styled from "styled-components";

import { LinkCard } from "@examspark/common-ui/dist/components/containers/LinkCard";
import { IconAddLine } from "@examspark/common-ui/dist/components/icons";
import { colorFromTheme } from "@examspark/common-ui/dist/utils/color";
import { UserClassroom } from "@examspark/types";

import ClassroomsGridItem from "./ClassroomsGridItem";
import NewClassroomModal from "./modals/NewClassroomModal";

export const StyledSectionBox = styled(LinkCard)`
  height: clamp(14rem, 25vh, 20rem);

  // change the highlight color
  &:hover,
  &:focus-within {
    --input-glow: transparent;
    border: solid 2px ${colorFromTheme("focus")};
  }
`;

export const NewSectionBox = styled(StyledSectionBox).attrs({
  as: "button",
})`
  align-items: center;
  justify-content: center;
  border: dashed 2px ${colorFromTheme("surface6")};
  transition: border 0.2s;
  cursor: pointer;
  color: #006699;
  font-family: inherit;
  font-size: 1.4rem;
  gap: 1rem;

  background-color: white;
  outline: transparent;

  svg {
    fill: #006699;
  }

  &:hover,
  &:focus-visible {
    border: dashed 2px ${colorFromTheme("focus")};
  }
`;

export const Grid = styled.div`
  gap: 1.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(26rem, 1fr));
`;

const ClassroomsGrid = (props: {
  classrooms: UserClassroom[];
  allowCreateClassroom?: boolean;
  hideNewClassroomCourseInputs?: boolean;
  allowedSubjects?: string[];
  disableGoogleClassroom?: boolean;
  view: {
    grade?: boolean;
    subject?: boolean;
    studentCount?: boolean;
  };
  onCreate?: () => void;
  onChange?: (classrooms?: UserClassroom[]) => void;
}) => {
  const [isNewModalOpen, setIsNewModalOpen] = useState(false);

  return (
    <>
      <NewClassroomModal
        // todo: split these up into separate props
        hideCourseInput={!!props.hideNewClassroomCourseInputs}
        hideSubjectInput={!!props.hideNewClassroomCourseInputs}
        hideGradeInput={!!props.hideNewClassroomCourseInputs}
        allowedSubjects={props.allowedSubjects}
        isOpen={isNewModalOpen}
        onRequestClose={() => setIsNewModalOpen(false)}
        disableGoogleClassroom={props.disableGoogleClassroom}
        onCreate={() => {
          setIsNewModalOpen(false);
          props.onCreate?.();
        }}
      />
      <Grid>
        {props.classrooms?.map(
          (section) =>
            section?.classroom && (
              <ClassroomsGridItem
                key={section.classroom.id}
                userClassroom={section}
                to={`/classroom/${section.classroom.id}`}
                view={props.view}
              />
            ),
        )}
        {props.allowCreateClassroom && (
          <NewSectionBox onClick={() => setIsNewModalOpen(true)}>
            <IconAddLine width="24" />
            <div>Add New Classroom</div>
          </NewSectionBox>
        )}
      </Grid>
    </>
  );
};

export default ClassroomsGrid;
